import { render } from "./TheAposAdminBarLocale.vue?vue&type=template&id=ef7bd79c&scoped=true"
import script from "./TheAposAdminBarLocale.vue?vue&type=script&lang=js"
export * from "./TheAposAdminBarLocale.vue?vue&type=script&lang=js"

import "./TheAposAdminBarLocale.vue?vue&type=style&index=0&id=ef7bd79c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7bd79c"],['__file',"admin-bar/ui/apos/components/TheAposAdminBarLocale.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef7bd79c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef7bd79c', __exports__)) {
    api.reload('ef7bd79c', __exports__)
  }
  
  module.hot.accept("./TheAposAdminBarLocale.vue?vue&type=template&id=ef7bd79c&scoped=true", () => {
    api.rerender('ef7bd79c', render)
  })

}


export default __exports__